import React, { useEffect, useState } from 'react'
import { string, bool, func, any } from 'prop-types'
import { Box, IconButton, styled, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import VideoModal from './modals/VideoModal'
const FileMiniature = ({ name, visible, removeAction, video }) => {
  const StyledBox = styled(Box)(() => ({
    display: visible ? 'flex' : 'none',
    flexDirection: 'column',
    alignItems: 'center',
    justifycontent: 'center',
    width: 150,
    boxShadow: '1px 1px 3px gray',
    background: 'white',
    padding: '0.5rem',
    borderRadius: '8px'
  }))

  const StyledText = styled(Typography)`
    font-size: 0.95rem;
    text-align: center;
    color: black;
    margin-top: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
  `
  const StyledDiv = styled('div')`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    /* background-color: red; */
  `

  const StyledButton = styled(IconButton)`
    padding: 0.1rem;
  `
  const removeFile = () => {
    removeAction()
  }
  const createVideoURL = video => URL.createObjectURL(video)
  const [videoURL, setVideoURL] = useState('')
  useEffect(() => {
    if (video) {
      const aux = createVideoURL(video)
      setVideoURL(aux)
    }
  }, [video])
  return (
    <StyledBox>
      <StyledDiv>
        <StyledButton onClick={removeFile}>
          <Close />
        </StyledButton>
      </StyledDiv>
      <VideoModal video={videoURL} />
      <StyledText>{name}</StyledText>
    </StyledBox>
  )
}

FileMiniature.propTypes = {
  name: string,
  visible: bool,
  removeAction: func,
  video: any
}

export default FileMiniature
